import AcceptInvitation from "components/auth/acceptInvitation";
import AtiSuCallback from "components/auth/atiSuCallback";
import ConfirmEmail from "components/auth/confirmEmail";
import CookieConsentModal from "components/auth/cookieConsentModal";
import ForgotPassword from "components/auth/forgotPassword";
import Login from "components/auth/login";
import Registration from "components/auth/registration";
import ResetPassword from "components/auth/resetPassword";
import UnsubscribeNotifications from "components/auth/unsubscribeNotifications";
import { useRouter } from "hooks/useRouter";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

const LoginContainer = (props: { token: string; children: React.ReactNode }) => {
    const { location, paths } = useRouter();

    if (location.pathname === paths.registrationCallbackAtiSu) {
        return (
            <>
                <AtiSuCallback isAuthenticated={Boolean(props.token)} />
                <CookieConsentModal />
            </>
        );
    }

    if (props.token) {
        return props.children;
    }

    return (
        <>
            <Switch location={location}>
                <Route exact path={paths.login} component={Login} />
                <Route exact path={paths.registration} component={Registration} />
                <Route exact path={paths.forgotPassword} component={ForgotPassword} />
                <Route exact path={paths.resetPassword} component={ResetPassword} />
                <Route exact path={paths.confirmEmail} component={ConfirmEmail} />
                <Route exact path={paths.acceptInvitation} component={AcceptInvitation} />
                <Route exact path={paths.unsubscribe} component={UnsubscribeNotifications} />
                <Redirect to={{ pathname: paths.login, state: { from: location.pathname } }} />
            </Switch>
            <CookieConsentModal />
        </>
    );
};

const mapStateToProps = (state: { profile: { token: string } }) => ({
    token: state.profile.token,
});

export default connect(mapStateToProps, () => ({}))(LoginContainer);
